import React from 'react';
import Logo from './Logo';
import Hamburg from './Hamburg';
import Search from './Search';
import './index.css'
const Navbar = () => {
    return (
        <nav className="bg-gradient-to-b from-black-100 to-transparent fixed z-10 w-full">
            <div className="md:container md:mx-auto px-8 py-4">
                <div className="flex justify-between items-center">
                    <Hamburg />
                    <Logo />
                    <Search />
                </div>
            </div>
        </nav>
    )
}

export default Navbar